
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When blockquote is used for testimonials or to emphasize excerpts of text. It is regarded as a standalone design component with a dominant appearance in the page.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Blockquote/Blockquote_996-1140px.svg",
        "alt": "An image of a Blockquote"
      }}></img></p>
    <h2>{`When to use it`}</h2>
    <p>{`To present a relevant quote or testimonial from someone prominent.`}</p>
    <h2>{`When not to use it`}</h2>
    <p>{`To indent a block of text.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;